import React from "react";
import "./LoaderLogo.css";

class LogoLoader extends React.Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="logo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 600 160"
        width="600"
        height="160"
      >
        <style>{`
          .name-text {
            font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
            font-weight: 700;
            letter-spacing: 6px;
            fill: none;
            stroke: ${theme.body};
            stroke-width: 1.5px;
            stroke-dasharray: 1200;
            stroke-dashoffset: 1200;
          }
          .line1 {
            font-size: 80px;
            animation: draw 2s ease forwards 0.5s;
          }
          .line2 {
            font-size: 42px;
            letter-spacing: 14px;
            animation: draw 2s ease forwards 1.5s;
          }
          .fill-text {
            fill: ${theme.body};
            stroke: none;
          }
          .line1-fill {
            animation: draw 2s ease forwards 0.5s, fillIn 0.4s ease forwards 2.3s;
          }
          .line2-fill {
            animation: draw 2s ease forwards 1.5s, fillIn 0.4s ease forwards 3.3s;
          }
          @keyframes draw {
            to {
              stroke-dashoffset: 0;
            }
          }
          @keyframes fillIn {
            to {
              fill: ${theme.body};
            }
          }
        `}</style>

        {/* Line 1: GHASSEN */}
        <text
          x="50%"
          y="88"
          textAnchor="middle"
          className="name-text line1 line1-fill"
        >
          GHASSEN
        </text>

        {/* Line 2: BEN NASSER */}
        <text
          x="50%"
          y="138"
          textAnchor="middle"
          className="name-text line2 line2-fill"
        >
          BEN NASSER
        </text>
      </svg>
    );
  }
}

export default LogoLoader;
